// generated by scripts/emit_composition_layout.py, do not edit
// Source of truth: apps/backend/api/constants/arrange_scopes.py
// Regenerate with `make generate-types`; CI fails on drift.

export const ARRANGE_CHOICES = [
  {
    "description": "Reorder and resize the blocks into sections. Their questions and chart types stay as they are.",
    "key": "layout",
    "label": "Layout only"
  },
  {
    "description": "Also pick a better chart type where one fits, and tidy the titles. The numbers stay the same.",
    "key": "presentation",
    "label": "Layout and presentation"
  },
  {
    "description": "Also drop empty blocks and re-ask a question that is not working. This can change what a block shows.",
    "key": "full",
    "label": "Layout, presentation and content"
  }
] as const;
